module.exports = __webpack_public_path__ + "static/media/nextBlackArrow.ec2ec320.svg";